<template>
  <b-modal
    id="ModId4"
    ref="modal"
    :title="modalTitle"
    size="lg"
    @ok="sendModalData($event)"
    @cancel="clearModal"
    @hidden="clearModal"
    ok-title="Сохранить" ok-variant="success"
    cancel-variant="danger" cancel-title="Отменить"
    :no-close-on-backdrop=true
    :ok-disabled="veeErrors.any() || $parent.supportCheck"
  >
    <b-container fluid v-if="!loading">
      <div class="modal-spinner">
        <b-spinner variant="secondary" label="Loading..."></b-spinner>
        <strong class="mt-3">Загрузка...</strong>
      </div>
    </b-container>
    <b-form ref="form" @submit.stop.prevent="onSubmit" v-else>
      <b-container fluid>
        <b-row>
          <b-form-group class="inline"
                        label="Является организацией"
                        label-class="mf-label"
                        label-for="is-org-input"
          >
            <b-form-checkbox id="is-org-input"
                             v-model="model.p_is_org"
                             type="checkbox"
                             class="ml-4"
            >
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <div v-if="model.p_is_org">
          <b-row class="pb-3">
            <b-col md="3" class="pl-0">
              <b-form-group
                label="ОПФ *"
                label-for="opf"
                label-class="mf-label"
              >
                <treeselect id="opf"
                            :options="selects"
                            v-model="model.p_opf"
                            placeholder="Выбрать..."
                            noResultsText="Ничего не найдено..."
                            :clearable=true
                            :label="'ОПФ *'"
                >
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
                </treeselect>
                <b-form-invalid-feedback id="opf-feedback">
                  Введите ОПФ.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="9" class="pr-0">
              <b-form-group
                label="Наименование *"
                label-for="fullname-input"
                label-class="mf-label"
                :invalid-feedback="getError('fullname-input')"
              >
                <b-form-input
                  id="fullname-input"
                  name="fullname-input"
                  v-validate="modelValidation.fullname"
                  data-vv-as="Наименование"
                  v-model="model.p_fullname"
                  placeholder="Наименование без ОПФ"
                  :state="validateState('fullname-input')"
                ></b-form-input>

              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="pb-3">
            <b-col md="3" class="pl-0">
              <b-form-group
                label="ИНН *"
                label-for="inn-input"
                label-class="mf-label"
                :invalid-feedback="getError('inn-input')"
              >
                <b-form-input
                  id="inn-input"
                  name="inn-input"
                  v-validate="modelValidation.inn"
                  v-model="model.p_inn"
                  data-vv-as="ИНН"
                  :placeholder="innPlaceholder"
                  :state="validateState('inn-input')"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3" class="pr-0">
              <b-form-group
                :label="kppData.label"
                label-for="kpp-input"
                label-class="mf-label"
                :invalid-feedback="getError('kpp-input')"
              >
                <b-form-input
                  id="kpp-input"
                  name="kpp-input"
                  data-vv-as="КПП"
                  v-validate="kppData.validation"
                  v-model="model.p_kpp"
                  :placeholder="kppData.placeholder"
                  :state="validateState('kpp-input')"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <b-row>
            <b-col md="12" class="pl-0">
              <b-form-group
                label="Наименование *"
                label-for="fullname-input"
                label-class="mf-label"
                :invalid-feedback="getError('fullname-input')"
              >
                <b-form-input
                  id="fullname-input"
                  name="fullname-input"
                  v-validate="modelValidation.fullname"
                  data-vv-as="Наименование"
                  v-model="model.p_fullname"
                  placeholder="Наименование без ОПФ"
                  :state="validateState('fullname-input')"
                ></b-form-input>

              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-container>

    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validation } from './validation'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'sub-group',
  mixins: [validation],
  components: {
    Treeselect
  },
  data () {
    return {
      loading: null,
      modalData: null,
      model: {
        p_is_org: false,
        p_opf: null,
        p_fullname: '',
        p_inn: '',
        p_kpp: ''
      },
      selects: null,
      modalTitle: ''
    }
  },
  watch: {
    modalParamsSubgroup () {
      this.model.p_is_org = Boolean(this.modalParamsSubgroup.method_data.p_is_org)
      this.model.p_fullname = this.modalParamsSubgroup.method_data.p_fullname
      this.model.p_inn = this.modalParamsSubgroup.method_data.p_inn
      this.model.p_kpp = this.modalParamsSubgroup.method_data.p_kpp
      this.model.p_opf = this.modalParamsSubgroup.method_data.p_opf
      this.selects = this.modalParamsSubgroup.selects.p_opf
    },
    subgroupDropdowns () {
      this.selects = this.subgroupDropdowns.p_opf
    }
  },
  computed: {
    innPlaceholder () {
      if (this.model.p_opf === 'ИП') {
        return '12 цифр'
      } else {
        return '10 цифр'
      }
    },
    kppData () {
      if (this.model.p_opf === 'ИП') {
        return {
          placeholder: 'Необязательно',
          label: 'КПП',
          validation: {
            required: false
          }
        }
      } else {
        return {
          placeholder: '9 цифр',
          label: 'КПП *',
          validation: {
            required: true,
            digits: 9
          }
        }
      }
    },
    ...mapState(
      {
        modalParamsSubgroup: state => state.groupsUsers.modalParamsSubgroup,
        subgroupDropdowns: state => state.groupsUsers.subgroupDropdowns
      }
    )
  },
  methods: {
    modalSubgroup (data) {
      if (data.add) {
        this.modalTitle = 'Добавление отдела/организации'
        this.$root.$emit('bv::show::modal', 'ModId4', event)
        this.getSubgroupDropdowns(data).then(
          () => {
            this.modalData = data
            this.loading = true
            this.sendMethod = 'create'
          }
        )
      } else {
        this.modalTitle = 'Редактирование отдела/организации'
        this.$root.$emit('bv::show::modal', 'ModId4', event)
        this.getSubgroupModalParams(data).then(
          () => {
            this.modalData = data
            this.loading = true
            this.sendMethod = 'edit'
          }
        )
      }
    },
    sendLogic () {
      if (this.sendMethod === 'create') {
        this.model.p_gid = this.modalData.p_gid
        this.model.p_is_org = Number(this.model.p_is_org)
        this.createSubgroup(this.model).then(
          (response) => {
            this.$emit('reloadGroups', response)
          },
          (error) => {
            console.log(error)
          }
        )
      } else if (this.sendMethod === 'edit') {
        this.model.p_is_org = Number(this.model.p_is_org)
        this.editSubgroup(this.model).then(
          (response) => {
            this.$emit('reloadGroups', response)
          },
          (error) => {
            console.log(error)
          }
        )
      }
    },
    sendModalData (event) {
      event.preventDefault()
      this.onSubmit()
    },
    clearModal () {
      for (const key in this.model) {
        this.model[key] = null
      }
      this.selects = null
      this.loading = false
      this.sendMethod = null
    },
    ...mapActions('groupsUsers', [
      'editSubgroup',
      'createSubgroup',
      'getSubgroupDropdowns',
      'getSubgroupModalParams'
    ])
  }
}
</script>

<style scoped>
  .inline {
    display: inline-flex;
  }

  .form-control::placeholder {
    font-size: 14px;
    color: #90A4AE;
    line-height: 20px;
  }

  input.form-control {
    font-size: 14px;
    line-height: 20px;
  }

  textarea.form-control {
    font-size: 14px;
    line-height: 20px;
  }

</style>
